import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import styled, { keyframes, css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';

import { FloatingButton, Button } from '~ui-kit';

import { fetchTasks } from '~actions/transferActions';

const UpdateButton = props => {
  const [time, setTime] = useState(null);

  useEffect(() => {
    const updateInterval = 6000; // try to make this a multiple of animation cycles
    const interval = setInterval(() => setTime(Date.now()), updateInterval);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const shouldNag = () => {
    const longTime = 3 * 60 * 1000; // 3 minutes
    return time - props.lastUpdated > longTime;
  };

  const { lastUpdated, isDesktop, fetchTasks } = props;
  const outdated = shouldNag(lastUpdated);

  const location = useLocation();

  return (
    <>
      <UpdateContainer>
        {/* <RefreshButton outdated={outdated && isDesktop} onClick={update}>
                <RefreshIcon
                  outdated={outdated && isDesktop}
                  className="fas fa-sync-alt"
                />
                <RefreshText outdated={outdated && isDesktop}>
                  päivitä
                </RefreshText>
              </RefreshButton> */}
        <LastUpdated>
          Tiedot päivitetty {moment(lastUpdated).format('DD.MM. HH.mm')}
        </LastUpdated>
        <StyledButton onClick={fetchTasks}>Päivitä</StyledButton>
      </UpdateContainer>
      {!isDesktop && outdated && location.pathname !== '/' && (
        <FloatingButton
          overrideFloater={
            <FloaterContainer key="floater">
              <Floater outdated={outdated} onClick={fetchTasks} />
              <FloaterText onClick={fetchTasks}>
                <FloaterIcon outdated={outdated} icon={faRedo} />
                <div>Päivitä</div>
              </FloaterText>
            </FloaterContainer>
          }
        />
      )}
    </>
  );
};

const LastUpdated = styled.div`
  text-align: right;
  color: var(--textGrey);
  font-size: 12px;
  opacity: 0.9;
`;

const UpdateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
`;

const StyledButton = styled(Button)`
  padding: 12px 24px;
`;

// const basePadding = 5;
// const growPadding = 4;

// const buttonKeyframes = keyframes`
//   0% {
//     padding: ${basePadding}px;
//     margin: ${growPadding}px;
//     border-radius: 8px;
//   }
//   50% {
//     padding: ${basePadding + growPadding}px;
//     margin: 0px;
//     border-radius: 4px;
//   }
//   100% {
//     padding: ${basePadding}px;
//     margin: ${growPadding}px;
//     border-radius: 8px;
//   }
// `;

// const outdatedMixin = css`
//   color: white;
//   background-color: #d68146;
//   animation: ${buttonKeyframes} 2s infinite;

//   &:hover {
//     color: white;
//   }
// `;

// const RefreshButton = styled.a`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   border-radius: 8px;
//   padding: 3px;

//   &:hover {
//     text-decoration: none;
//     color: #163979;
//     cursor: pointer;
//   }

//   & > * {
//     margin: unset;
//   }

//   & > p {
//     margin-bottom: 2px;
//   }

//   ${props => (props.outdated ? outdatedMixin : '')}
// `;

// const RefreshIcon = styled.i`
//   color: ${props => (props.outdated ? 'white' : '#163979')};
//   font-size: 1.1em;
//   margin-right: 5px;
//   margin-left: 2px;
//   line-height: 1.5;
// `;

// const RefreshText = styled.p`
//   color: ${props => (props.outdated ? 'white' : '#163979')};
// `;

// Floater stuff
const floaterSize = 86;

const floaterKeyframes = keyframes`
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.0);
  }
  100% {
    transform: scale(0.8);
  }
`;

const outdatedFloaterMixin = css`
  animation: ${floaterKeyframes} 2s infinite;
`;

const FloaterContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 30px;

  display: flex;
  align-items: center;
  justify-content: space-around;

  width: ${floaterSize}px;
  height: ${floaterSize}px;

  z-index: 2;
  cursor: pointer;
`;

const Floater = styled.div`
  width: ${floaterSize}px;
  height: ${floaterSize}px;
  background-color: #d68146;
  border-radius: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  cursor: pointer;

  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);

  ${props => (props.outdated ? outdatedFloaterMixin : 'display: none;')}
`;

const FloaterText = styled.span`
  position: absolute;
  color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;
`;

const FloaterIcon = styled(FontAwesomeIcon)`
  font-size: 1.1em;
  line-height: 1.5;
`;

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTasks,
    },
    dispatch
  );

export default connect(
  state => ({
    lastUpdated: state.transferReducers.lastUpdated,
    isDesktop: state.reducer.isDesktop,
  }),
  mapDispatchToProps
)(UpdateButton);
